import { Component, OnInit } from '@angular/core';
import { Checklist } from "../../../classes/checklist";
import { ChecklistCategory } from "../../../classes/checklistCategory";
import { ChecklistCategoryService } from '../../../services/checklistCategory';
import { HttpErrorResponse } from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {ChecklistService} from "../../../services/checklist";

@Component({
  selector: 'app-checklist-create',
  templateUrl: './checklist-category-create.component.html',
  styleUrls: ['./checklist-category-create.component.css']
})
export class ChecklistCategoryCreateComponent implements OnInit {

  checklist = new Checklist();
  checklistCategory = new ChecklistCategory();
  checklistCategoryCreationResult = true;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private checklistService: ChecklistService,
              private checklistCategoryService: ChecklistCategoryService) { }

  ngOnInit(): void {
      this.route.paramMap.subscribe(params => {
          this.checklistService.getByID(params.get('id'))
              .subscribe({
                  next: (checklist: any) => {
                      this.checklist = checklist;
                      this.checklistCategory.fk_id_checklist = this.checklist.id_checklist;
                  },
                  error: (err: HttpErrorResponse) => {
                      console.log(err);
                  }
              });
      });
  }

  onSubmit() {
    this.checklistCategoryService.create(this.checklistCategory)
      .subscribe({
        next: () => {
          this.router.navigate(['/checklist/' + this.checklist.id_checklist]);
        },
        error: (err: HttpErrorResponse) => {
          this.checklistCategoryCreationResult = false;
          console.log(err);
        }
      });
  }

}
